<template>
  <div class="common-pannel">
    <h2 v-if="title" class="pannel-title">{{title}}</h2>
    <div class="pannel-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "common-panel",
  props: {
    title: {
      type: String,
      description: "title"
    }
  }
};
</script>
<style scoped lang="scss">

</style>
